import React from 'react'
import { VideoItem } from '../../../Types/modeltypes'

type Props = {
    data: VideoItem[]
}

const VideoList: React.FC<Props> = ({ data }) => {
    return (
        <div style={styles.container}>

            {data.map((item, index) => (
                <div key={index} style={styles.card}>

                    <h3 style={styles.title}>{item.title}</h3>
                    <video
                        src={item.videoUrl}
                        controls
                        preload="metadata"
                        style={styles.video}
                    />
                </div>
            ))}
        </div>
    )
}

export default VideoList

// Styles (typed)
const styles: { [key: string]: React.CSSProperties } = {
    container: {
        padding: 10,
        display: "flex",
        flexDirection: "column",
        gap: 20
    },
    card: {
        backgroundColor: "#fff",
        borderRadius: 12,
        padding: 10,
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
    },
    title: {
        marginBottom: 10
    },
    video: {
        width: "100%",
        maxHeight: 400,
        borderRadius: 10
    }
}